import { render, staticRenderFns } from "./project-storehouse.vue?vue&type=template&id=376efc85"
import script from "./project-storehouse.vue?vue&type=script&lang=js"
export * from "./project-storehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports